/**
 * Generic event listener thing.
 *
 * Some ideas going forward:
 *   - `on` could return the un-subscriber
 *   - `on` could prevent dupe subscribers
 *
 * @namespace Event
 * @version 1.0.0
 */
export default class Event {
  events = {}

  /**
   * Subscribes a method to an event name.
   * @function
   * @instance
   * @memberof Event
   */
  on = (name: string, method: Function) => {
    this.events[name] = [...(this.events[name] || []), method]
  }

  /**
   * Un-subscribes a method to an event name.
   * @function
   * @instance
   * @memberof Event
   */
  off = (name: string, method: Function) => {
    this.events[name] = this.events[name].filter(m => m !== method)
  }

  /**
   * Emits an event, calling all subscribed methods.
   * @function
   * @instance
   * @memberof Event
   */
  emit = (name: string, data: Object) => {
    this.events[name] ? this.events[name].forEach(m => m(data)) : false
  }

  /**
   * Un-subscribes all events.
   * @function
   * @instance
   * @memberof Event
   */
  reset = () => {
    this.events = {}
  }
}
